import React, { useEffect } from 'react'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Router from './Router'
import { ThemeProvider } from '@material-ui/styles'
// import { ConfigProvider } from './ConfigContext'
import theme from './OverrideMUITheme'
import './ExtendAxios'

const App = () => {
  useEffect(() => {
    switch (process.env.REACT_APP_NODE_ENV) {
      case 'local':
        document.title = process.env.REACT_APP_LOCAL_TITLE
        break
      case 'development':
        document.title = process.env.REACT_APP_DEV_TITLE
        break
      case 'base':
        document.title = process.env.REACT_APP_BASE_TITLE
        break
      case 'staging':
        document.title = process.env.REACT_APP_STAGING_TITLE
        break
      case 'test':
        document.title = process.env.REACT_APP_TEST_TITLE
        break
      default:
        document.title = process.env.REACT_APP_PROD_TITLE
        break
    }
  }, [])
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router />
        </PersistGate>
      </Provider>
    </ThemeProvider>
  )
}

export default App
